export branch = '$config'
export graph = branch
export memberKey = 'type' # model member key: not to be confused with configurable app memberKeys
export inheritKey = 'subType'
export version = '2.0.0'

export namespaces = {
  "http://www.w3.org/ns/dcat#": "dcat:"
  "http://purl.org/dc/dcmitype/": "dcm:"
  "http://purl.org/dc/terms/": "dct:"
  "http://www.w3.org/ns/dqv#": "dqv:"
  "http://www.w3.org/ns/entailment/": "entailment:"
  "http://definities.geostandaarden.nl/def/nen3610#": "nen3610:"
  "http://www.w3.org/ns/owl-profile/": "profile:"
  "http://www.w3.org/ns/formats/": "fmt:"
  "http://xmlns.com/foaf/0.1/": "foaf:"
  "http://www.opengis.net/ont/geosparql#": "geo:"
  "http://www.opengis.net/ont/gml#": "gml:"
  "http://www.w3.org/2016/05/ldqd#": "ldqd:"
  "http://www.w3.org/ns/oa#": "oa:"
  "http://www.w3.org/2002/07/owl#": "owl:"
  "http://www.w3.org/ns/prov#": "prov:"
  "http://www.w3.org/1999/02/22-rdf-syntax-ns#": "rdf:"
  "http://www.w3.org/2000/01/rdf-schema#": "rdfs:"
  "http://www.w3.org/ns/sparql-service-description#": "sd:"
  "https://schema.org/": "sdo:"
  "http://www.w3.org/ns/shacl#": "sh:"
  "http://www.w3.org/2004/02/skos/core#": "skos:"
  "http://purl.org/vocab/vann/": "vann:"
  "http://rdfs.org/ns/void#": "void:"
  "http://www.w3.org/2001/XMLSchema#": "xsd:"
}
